/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const interviewBookingTokenResponseStatusSchema = z.enum([
	'pending',
	'booked',
	'cancelled',
	'expired',
	'invalidated',
])

export type InterviewBookingTokenResponseStatusSchema = z.infer<typeof interviewBookingTokenResponseStatusSchema>
